export default "__VITE_ASSET__wHZ3$PLt__"